import React, { useEffect, useRef, useCallback, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import stringify from '../utils/stableStringify';
import { unpack, pack } from 'msgpackr';
import AntTime from '../utils/AntTime';
import AntConfig from '../utils/AntConfig';
import { Validator } from 'devextreme-react/validator';
import { Template } from 'devextreme-react/core/template';
import { DropDownBox } from 'devextreme-react';
import { TreeList, Selection, Paging, FilterRow, Scrolling } from 'devextreme-react/tree-list';
import AntQueryStore from './AntQueryStore';
import AntGridBar from './AntGridBar';
import AntString from '../utils/AntString';
import AntArray from '../utils/AntArray';
import AntLocalization from '../utils/AntLocalization';
import AntCategory from '../utils/AntCategory';

import { AntGlobal, AntSession } from '../utils/AntContext';

export default function (props) {
    const appGlobal = AntGlobal();
    // const session = AntSession();

    if (props.API && !props.API.entityDisplay) {
        if (appGlobal && appGlobal.appConfig && appGlobal.appConfig.Services) {
            let found = appGlobal.appConfig.Services.find((s) => s.name === props.API.entityName);
            if (found) props.API.init({ entityDisplay: found.display });
        }
    }

    const tableName = props.treeOptions && props.treeOptions.table ? props.treeOptions.table : props.table ? props.table : props.API.entityName;

    const config = useMemo(() => {
        let found = appGlobal.tableConfigs?.find((t) => t.tableName === tableName);
        if (found) return found.config;

        let cnf = new AntConfig(appGlobal, tableName);
        cnf.configFields(props.fields);

        if (appGlobal.tableConfigs instanceof Array === false) appGlobal.tableConfigs = [];

        appGlobal.tableConfigs.push({
            tableName: tableName,
            config: cnf
        });
        return cnf;
    }, []);

    const CategoryData = useMemo(() => new AntCategory(appGlobal.appAssets.data.categoryData), []);

    const initDataSource = () => {
        let obj;

        if (props.isRemote) {
            obj = new AntQueryStore({
                key: props.treeOptions.valueExpr,
                API: props.API,
                url: props.url,
                loadFunc: 'postLookup',
                remotePaging: props.remotePaging !== undefined ? props.remotePaging : false,
                getSearchConditions: getSearchConditions,
                getQueryFields: getQueryFields,
                getSearchText: getSearchText
            });
        }

        return obj;
    };

    const initActionConditions = () => {
        let ar = [];

        if (props.treeOptions && props.treeOptions.actionItems instanceof Array)
            props.treeOptions.actionItems.forEach((item) => {
                if (item.name)
                    ar.push({
                        name: item.name,
                        value: item.defaultValue !== undefined ? item.defaultValue : null
                    });
            });
        return ar;
    };

    const getSearchConditions = () => {
        var obj = {
            lkTableName: props.lkTableName ? props.lkTableName : props.options && props.options.table ? props.options.table : props.table,
            lkName: !props.url && props.lookupName ? props.lookupName : undefined
        };
        actionConditions.forEach((c) => {
            if (c.name && c.value !== undefined) obj[c.name] = c.value;
        });

        if (typeof props.searchConditions === 'object' && props.searchConditions !== null)
            Object.keys(props.searchConditions).forEach((k) => {
                if (props.searchConditions[k] !== undefined) obj[k] = props.searchConditions[k];
            });

        if (props.parentFields instanceof Array) {
            var formData = null;
            if (props.formRef) formData = props.formRef.option('formData');
            if (formData) {
                props.parentFields.forEach((field) => {
                    if (typeof field === 'object' && field !== null) {
                        var parentField = field.field;
                        var aliasField = field.alias;
                        if (formData && formData[parentField] !== undefined && formData[parentField] !== null)
                            obj[aliasField] = formData[parentField];
                    } else if (formData && formData[field] !== undefined && formData[field] !== null) obj[field] = formData[field];
                });
            }
        }

        Object.keys(obj).map((k) => {
            if (obj[k] === null) obj[k] = undefined;
        });

        Object.keys(obj).forEach((key) => {
            if (obj[key] === undefined) {
                delete obj[key];
            }
        });

        obj.isSearching = props.isSearching !== undefined ? props.isSearching : true;
        return obj;
    };

    const getQueryFields = () => {
        var ar = [
            'created_at',
            'checksum',
            'id',
            'code',
            props.treeOptions.valueExpr,
            props.treeOptions.displayExpr,
            props.treeOptions.keyExpr,
            props.treeOptions.parentIdExpr
        ];

        if (props.treeOptions && props.treeOptions.columns instanceof Array) {
            for (let i = 0; i < props.treeOptions.columns.length; i++) {
                const c = props.treeOptions.columns[i];

                var fieldName = null;
                if (typeof c === 'string') {
                    fieldName = String(c);
                } else if (typeof c === 'object' && c.dataField) fieldName = c.dataField;

                var col1 = mainColumns.find((c1) => c1.dataField === fieldName);
                if (col1 && (col1.colType === 'join' || col1.colType === 'first' || col1.colType === 'last') && col1.fields instanceof Array)
                    ar.push(...col1.fields);
                else ar.push(fieldName);
            }

            ar.push(
                ...Array.from(props.treeOptions.columns, (c) =>
                    typeof c === 'object' && c.defaultValue && typeof c.defaultValue === 'object' && c.defaultValue.rowField
                        ? c.defaultValue.rowField
                        : undefined
                )
            );
        }

        if (props.getQueryFields) {
            var fields = props.getQueryFields();
            if (fields instanceof Array) ar.push(...fields);
        }

        ar = ar
            .filter((v) => Boolean(v))
            .filter((v, index, self) => {
                return self.indexOf(v) === index;
            });

        return ar;
    };

    const getSearchText = () => {
        return searchText.current;
    };

    const onSearchText = (text) => {
        searchText.current = text;
        if (tree.current) tree.current.refresh();
    };

    const onAction = async (e) => {
        if (e.name) {
            var cond = actionConditions.find((c) => c.name === e.name);
            if (cond) {
                cond.value = e.value;
            } else setActionConditions([...actionConditions, { name: e.name, value: e.value }]);
        }

        if (tree.current) tree.current.refresh();
    };

    const renderLookupButton = () => {
        return (
            <i
                className={'dx-icon dx-icon-search'}
                style={{
                    marginTop: '8px',
                    display: 'inline-block',
                    fontSize: '20px'
                }}
            ></i>
        );
    };

    const onOpened = (e) => {
        if (tree.current) {
            if (props.refreshOnOpened || (props.treeOptions && props.treeOptions.refreshOnOpened)) tree.current.refresh();
        }
    };

    const resetColumnVisibility = () => {
        if (props.treeOptions && props.treeOptions.columns instanceof Array)
            props.treeOptions.columns.forEach((col) => {
                var visible = true;
                if (typeof col.visible === 'object' && col.visible.type === 'action' && col.visible.field) {
                    visible = false;
                    var cond = actionConditions.find((cond) => cond.name === col.visible.field);
                    if (cond && cond.value !== undefined) visible = cond.value === col.visible.value;
                } else if (typeof col.visible === 'boolean') visible = col.visible;

                if (visible) {
                    if (col.config) {
                        var formData = null;
                        if (props.formRef) formData = props.formRef.option('formData');
                        visible = AntCondition.isVisible(formData, col.config);
                    }
                }

                if (tree.current) tree.current.columnOption(col.dataField, 'visible', visible);
            });
    };

    const renderCheckboxCell = (cell) => {
        return <CheckBox value={cell.value} hoverStateEnabled={false} activeStateEnabled={false} focusStateEnabled={false} />;
    };

    const initColumns = () => {
        var formData = null;
        if (props.formRef) formData = props.formRef.option('formData');

        var columns = [];

        if (props.treeOptions && props.treeOptions.columns instanceof Array) {
            props.treeOptions.columns.forEach((col) => {
                if (typeof col === 'string') {
                    var dataField = String(col);
                    columns.push({ dataField: dataField, name: 'col' + dataField });
                } else if (typeof col === 'object' && col.dataField) columns.push({ ...col, name: 'col' + col.dataField });
            });
        }

        var maxHidingPriority = 0;
        columns.forEach((col) => {
            var colType = col.dataType;
            var colEditor = col.editor;
            var colLabel = col.caption ? col.caption : col.label;
            var colLookupValues = col.lookup && col.lookup.values instanceof Array ? col.lookup.values : null;

            var colWidth = col.width;
            var colMinWidth = col.minWidth !== undefined ? col.minWidth : col.width;

            if (colLabel) {
                var labelWidth = AntString.measureColumnWidth(colLabel);
                if (!colWidth || colWidth < labelWidth) colWidth = labelWidth;
            }

            col.width = colWidth;
            col.minWidth = colMinWidth;

            if (col.hidingPriority !== undefined && col.hidingPriority > maxHidingPriority) maxHidingPriority = col.hidingPriority;

            var found = null;
            if (config) {
                if (col.dataField || col.cnfField) {
                    var tableName = col.cnfTable
                        ? col.cnfTable
                        : props.treeOptions && props.treeOptions.table
                        ? props.treeOptions.table
                        : props.table
                        ? props.table
                        : props.API.entityName;

                    var strField = col.cnfField ? col.cnfField : col.dataField;
                    found = config.getCnfField(strField, tableName);
                    if (found) {
                        if (!colType && found.dataType) colType = found.dataType;
                        if (!colLabel && found.treeLabel) colLabel = found.treeLabel;
                        if (!colLabel && found.label) colLabel = found.label;
                        if (!colLookupValues && found.lookup && found.lookup.values instanceof Array) colLookupValues = found.lookup.values;
                    }

                    if (found && found.cnfTable) {
                        var tableName = found.cnfTable;

                        var strField = found.cnfField ? found.cnfField : col.dataField;
                        found = config.getCnfField(strField, tableName);
                    }
                    if (found) {
                        if (!colType && found.dataType) colType = found.dataType;
                        if (!colLabel && found.treeLabel) colLabel = found.treeLabel;
                        if (!colLabel && found.label) colLabel = found.label;
                        if (!colLookupValues && found.lookup && found.lookup.values instanceof Array) colLookupValues = found.lookup.values;
                    }
                }
            }

            col.colType = colType;

            if (colLookupValues instanceof Array) {
                col.calculateCellValue = (data) => {
                    if (data) {
                        var colValue = data[col.dataField];
                        if (colValue != null) {
                            var obj = colLookupValues.find((f) => f.code === colValue);
                            if (obj) return obj.name;
                        }
                        return colValue;
                    }
                    return null;
                };
            }

            // if (col.defaultSort) {
            //     col.sortIndex = 0;
            //     col.sortOrder = col.defaultSort.order ? col.defaultSort.order : 'asc';
            //     // that.state.sortByColumn = col.dataField;
            //     // that.state.sortType = col.sortOrder;
            // }
            colLabel = AntLocalization.translateText(colLabel);
            col.caption = colLabel;

            if (colType === 'bool' || colEditor == 'CheckBox') {
                if (!col.alignment) col.alignment = 'center';

                col.calculateCellValue = (data) => {
                    if (data) {
                        if (typeof data[col.dataField] == 'boolean') return data[col.dataField];

                        if (typeof data[col.dataField] == 'number') return data[col.dataField] != 0;

                        // if (data[col.dataField] === 1) return true;

                        if (colType === 'bool') return parseInt(data[col.dataField]) === 1;
                        if (colType === 'int') return parseInt(data[col.dataField]) > 0;
                        if (colType === 'float') return parseFloat(data[col.dataField]) > 0;
                        else return parseFloat(data[col.dataField]) > 0;
                    }
                    return false;
                };
                col.cellTemplate = 'renderCheckboxCell';
                col.dataType = 'boolean';
            }

            if (colType === 'int') {
                if (!col.format) col.format = { type: 'fixedPoint' };
                if (!col.alignment) col.alignment = 'right';
                col.calculateCellValue = (data) => {
                    if (data && data[col.dataField] != null) return parseInt(data[col.dataField]);
                    else return 0;
                };
                col.dataType = 'number';
            }

            if (colType === 'float' || colType === 'decimal') {
                if (!col.format) col.format = '#,##0.' + String('#').repeat(found && found.decimalDigit ? found.decimalDigit : 2);

                if (!col.alignment) col.alignment = 'right';
                col.calculateCellValue = (data) => {
                    if (data && data[col.dataField] != null) return parseFloat(data[col.dataField]);
                    else return 0;
                };
                col.dataType = 'number';
            }

            if (colType === 'day') {
                if (!col.format) {
                    let strEnd = AntLocalization.translateText({ vi: 'ngày', en: 'day', fr: 'jour', es: 'día', id: 'hari', ja: '日', zh: '天', ko: '일', hi: 'दिन', ar: 'يوم' });
                    col.format = '#,##0 ' + strEnd;
                }
                if (!col.alignment) col.alignment = 'right';
                col.calculateCellValue = (data) => {
                    if (data && data[col.dataField] != null) return parseFloat(data[col.dataField]);
                    else return 0;
                };
                col.dataType = 'number';
            }

            if (colType === 'month') {
                if (!col.format) {
                    let strEnd = AntLocalization.translateText({ vi: 'tháng', en: 'month', fr: 'mois', es: 'mes', id: 'bulan', ja: '月', zh: '个月', ko: '개월', hi: 'महीना', ar: 'شهر' });
                    col.format = '#,##0 ' + strEnd;
                }
                if (!col.alignment) col.alignment = 'right';
                col.calculateCellValue = (data) => {
                    if (data && data[col.dataField] != null) return parseFloat(data[col.dataField]);
                    else return 0;
                };
                col.dataType = 'number';
            }

            if (colType === 'year') {
                if (!col.format) {
                    let strEnd = AntLocalization.translateText({ vi: 'năm', en: 'year', fr: 'an', es: 'año', id: 'tahun', ja: '年', zh: '年', ko: '년', hi: 'वर्ष', ar: 'سنة' });
                    col.format = '#,##0 ' + strEnd;
                }

                if (!col.alignment) col.alignment = 'right';
                col.calculateCellValue = (data) => {
                    if (data && data[col.dataField] != null) return parseFloat(data[col.dataField]);
                    else return 0;
                };
                col.dataType = 'number';
            }
            if (colType === 'period') {
                if (!col.format) {
                    let strEnd = AntLocalization.translateText({ vi: 'kỳ', en: 'period', fr: 'période', es: 'período', id: 'periode', ja: '期間', zh: '期', ko: '기간', hi: 'अवधि', ar: 'فترة' });
                    col.format = '#,##0 ' + strEnd;
                }

                if (!col.alignment) col.alignment = 'right';
                col.calculateCellValue = (data) => {
                    if (data && data[col.dataField] != null) return parseFloat(data[col.dataField]);
                    else return 0;
                };
                col.dataType = 'number';
            }

            if (colType === 'percent') {
                if (!col.format)
                    col.format = {
                        type: 'percent',
                        precision: found.decimalDigit ? found.decimalDigit : 0
                    };
                if (!col.alignment) col.alignment = 'right';
                col.calculateCellValue = (data) => {
                    if (data && data[col.dataField] != null) return parseFloat(data[col.dataField]);
                    else return 0;
                };
                col.dataType = 'number';
            }

            if (colType === 'currency') {
                if (!col.format) {
                    let strEnd = AntLocalization.translateCurrency(0);
                    strEnd = String(strEnd).slice(-1);
                    col.format = '#,##0 ' + strEnd;
                }

                // if (!col.format) col.format = '#,##0 đ';
                if (!col.alignment) col.alignment = 'right';
                col.calculateCellValue = (data) => {
                    if (data && data[col.dataField] != null) return parseInt(data[col.dataField]);
                    else return 0;
                };
                col.dataType = 'number';
            }

            if (colType === 'date') {
                if (!col.alignment) col.alignment = 'center';
                if (!col.format)
                    col.format = function (value) {
                        if (!value) return '';

                        if (AntTime.isUnixWithinToDay(value)) {
                            if (col.showTimeWithinToday) return AntTime.fromUnix(value).format('HH:mm');
                            else
                                return AntLocalization.translateText({ vi: 'Hôm nay', en: 'Today', fr: 'Aujourd\'hui', es: 'Hoy', id: 'Hari ini', ja: '今日', zh: '今天', ko: '오늘', hi: 'आज', ar: 'اليوم' });
                        }

                        if (AntTime.isUnixWithinYesterday(value))
                            return AntLocalization.translateText({ vi: 'Hôm qua', en: 'Yesterday', fr: 'Hier', es: 'Ayer', id: 'Kemarin', ja: '昨日', zh: '昨天', ko: '어제', hi: 'कल (बीता)', ar: 'أمس' });

                        if (AntTime.isUnixWithinTomorrow(value))
                            return AntLocalization.translateText({ vi: 'Ngày mai', en: 'Tomorrow', fr: 'Demain', es: 'Mañana', id: 'Besok', ja: '明日', zh: '明天', ko: '내일', hi: 'कल (आने वाला)', ar: 'غداً' });

                        if (AntTime.isUnixWithinCurrentYear(value)) return AntTime.fromUnix(value).format('DD/MM');

                        if (col.showTimeWithinToday) return AntTime.fromUnix(value).format('DD/MM');

                        return AntTime.fromUnix(value).format('DD/MM/YY');
                    };
                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);

                    var value = data ? data[col.dataField] : null;
                    if (value === null || value === undefined) return value;
                    if (typeof value === 'number') return parseFloat(value);

                    return value;
                };
                col.calculateDisplayValue = (data) => {
                    var value = data ? data[col.dataField] : null;
                    if (typeof value === 'number') value = parseFloat(value);

                    if (col.customDisplay) value = col.customDisplay(data);
                    else if (col.config && col.config.customDisplay) value = col.config.customDisplay(data);

                    if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                    if (value === null || value === undefined) value = '';

                    return value;
                };
                col.dataType = 'date';
            }

            if (colType === 'datetime') {
                if (!col.alignment) col.alignment = 'center';
                if (!col.format)
                    col.format = function (value) {
                        if (!value) return '';

                        if (AntTime.isUnixWithinToDay(value)) return AntTime.fromUnix(value).format('HH:mm');

                        if (AntTime.isUnixWithinCurrentYear(value)) return AntTime.fromUnix(value).format('DD/MM HH:mm');

                        return AntTime.fromUnix(value).format('DD/MM/YY');
                    };
                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);

                    var value = data ? data[col.dataField] : null;
                    if (value === null || value === undefined) return value;
                    if (typeof value === 'number') return parseFloat(value);

                    return value;
                };

                col.calculateDisplayValue = (data) => {
                    var value = data ? data[col.dataField] : null;
                    if (typeof value === 'number') value = parseFloat(value);

                    if (col.customDisplay) value = col.customDisplay(data);
                    else if (col.config && col.config.customDisplay) value = col.config.customDisplay(data);

                    if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                    if (value === null || value === undefined) value = '';

                    return value;
                };
                col.dataType = 'date';
            }

            if (colType === 'time') {
                if (!col.alignment) col.alignment = 'center';
                if (!col.format) col.format = 'hh:mm a';

                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);

                    var value = data ? data[col.dataField] : null;
                    if (value === null || value === undefined) return value;
                    if (typeof value === 'number') return parseFloat(value);

                    return value;
                };

                col.calculateDisplayValue = (data) => {
                    var value = data ? data[col.dataField] : null;
                    if (typeof value === 'number') value = AntTime.fromUnix(parseFloat(value)).toDate();

                    if (col.customDisplay) value = col.customDisplay(data);
                    else if (col.config && col.config.customDisplay) value = col.config.customDisplay(data);

                    if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                    if (value === null || value === undefined) value = '';

                    return value;
                };

                col.dataType = 'date';
            }

            if (colType === 'join') {
                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);
                    var fields = col.fields;
                    if (fields instanceof Array) {
                        var tableName = col.cnfTable
                            ? col.cnfTable
                            : props.treeOptions && props.treeOptions.table
                            ? props.treeOptions.table
                            : props.table
                            ? props.table
                            : props.API.entityName;

                        var ar = [];

                        for (let i = 0; i < fields.length; i++) {
                            const fField = fields[i];

                            var found = config.getCnfField(fField, tableName);
                            if (found && found.cnfTable) found = config.getCnfField(found.cnfField, found.cnfTable ? found.cnfTable : tableName);

                            var valueField = found && found.lookup && found.lookup.valueField ? found.lookup.valueField : 'code';
                            var displayField = found && found.lookup && found.lookup.displayField ? found.lookup.displayField : 'name';
                            var lookupValues = found && found.lookup && found.lookup.values instanceof Array ? found.lookup.values : [];

                            var fValue = data[fField];
                            if (fValue != null) {
                                var obj = lookupValues.find((f) => f[valueField] === fValue);
                                if (obj) fValue = obj[displayField];
                            }

                            if (typeof fValue === 'string') fValue = String(fValue);
                            if (fValue === AntLocalization.translateText({ vi: 'Không', en: 'None', fr: 'Aucun', es: 'Ninguno', id: 'Tidak ada', ja: 'なし', zh: '无', ko: '없음', hi: 'कोई नहीं', ar: 'لا شيء' }) && col.displayNoneAsEmpty !== false)
                                fValue = '';
                            if (fValue === null || fValue === undefined) fValue = '';

                            if (fValue && parseInt(fValue) && String(fField).endsWith('_adm2_name'))
                                fValue = AntLocalization.translateText({ vi: 'Quận', en: 'Dist', fr: 'District', es: 'Distrito', id: 'Distrik', ja: '地区', zh: '区', ko: '구역', hi: 'जिला', ar: 'منطقة' }) + ' ' + fValue;

                            ar.push(fValue);
                        }
                        ar = AntArray.distinct(
                            ar
                                .flat()
                                .filter((f) => Boolean(f))
                                .map((f) => String(f))
                        );
                        return ar.join(col.separator ? col.separator : ', ');
                    }

                    return '';
                };
                col.dataType = 'string';
            }

            if (colType === 'first') {
                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);
                    var fields = col.fields;
                    if (fields instanceof Array) {
                        var tableName = col.cnfTable
                            ? col.cnfTable
                            : props.treeOptions && props.treeOptions.table
                            ? props.treeOptions.table
                            : props.table
                            ? props.table
                            : props.API.entityName;

                        var ar = [];

                        for (let i = 0; i < fields.length; i++) {
                            const fField = fields[i];

                            var found = config.getCnfField(fField, tableName);
                            if (found && found.cnfTable) found = config.getCnfField(found.cnfField, found.cnfTable ? found.cnfTable : tableName);

                            var valueField = found && found.lookup && found.lookup.valueField ? found.lookup.valueField : 'code';
                            var displayField = found && found.lookup && found.lookup.displayField ? found.lookup.displayField : 'name';
                            var lookupValues = found && found.lookup && found.lookup.values instanceof Array ? found.lookup.values : [];

                            var fValue = data[fField];
                            if (fValue != null) {
                                var obj = lookupValues.find((f) => f[valueField] === fValue);
                                if (obj) fValue = obj[displayField];
                            }

                            if (typeof fValue === 'string') fValue = String(fValue);
                            if (fValue === AntLocalization.translateText({ vi: 'Không', en: 'None', fr: 'Aucun', es: 'Ninguno', id: 'Tidak ada', ja: 'なし', zh: '无', ko: '없음', hi: 'कोई नहीं', ar: 'لا شيء' }) && col.displayNoneAsEmpty !== false)
                                fValue = '';
                            if (fValue === null || fValue === undefined) fValue = '';
                            ar.push(fValue);
                        }
                        return ar
                            .filter((f) => Boolean(f))
                            .map((f) => String(f))
                            .shift();
                    }

                    return '';
                };
                col.dataType = 'string';
            }

            if (colType === 'last') {
                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);
                    var fields = col.fields;
                    if (fields instanceof Array) {
                        var tableName = col.cnfTable
                            ? col.cnfTable
                            : props.treeOptions && props.treeOptions.table
                            ? props.treeOptions.table
                            : props.table
                            ? props.table
                            : props.API.entityName;

                        var ar = [];

                        for (let i = 0; i < fields.length; i++) {
                            const fField = fields[i];

                            var found = config.getCnfField(fField, tableName);
                            if (found && found.cnfTable) found = config.getCnfField(found.cnfField, found.cnfTable ? found.cnfTable : tableName);

                            var valueField = found && found.lookup && found.lookup.valueField ? found.lookup.valueField : 'code';
                            var displayField = found && found.lookup && found.lookup.displayField ? found.lookup.displayField : 'name';
                            var lookupValues = found && found.lookup && found.lookup.values instanceof Array ? found.lookup.values : [];

                            var fValue = data[fField];
                            if (fValue != null) {
                                var obj = lookupValues.find((f) => f[valueField] === fValue);
                                if (obj) fValue = obj[displayField];
                            }

                            if (typeof fValue === 'string') fValue = String(fValue);
                            if (fValue === AntLocalization.translateText({ vi: 'Không', en: 'None', fr: 'Aucun', es: 'Ninguno', id: 'Tidak ada', ja: 'なし', zh: '无', ko: '없음', hi: 'कोई नहीं', ar: 'لا شيء' }) && col.displayNoneAsEmpty !== false)
                                fValue = '';
                            if (fValue === null || fValue === undefined) fValue = '';
                            ar.push(fValue);
                        }
                        return ar
                            .filter((f) => Boolean(f))
                            .map((f) => String(f))
                            .pop();
                    }

                    return '';
                };
                col.dataType = 'string';
            }

            if (!col.alignment && String(col.dataField).endsWith('status')) col.alignment = 'center';
            if (!col.alignment) col.alignment = 'left';
            if (col.link) col.cellTemplate = 'renderLinkCell';

            var visible = true;
            if (typeof col.visible === 'object') {
                if (col.visible.type === 'action' && col.visible.field) {
                    visible = false;
                    var cond = actionConditions.find((cond) => cond.name === col.visible.field);
                    if (cond && cond.value !== undefined) visible = cond.value === col.visible.value;
                } else {
                    visible = AntCondition.isVisible(formData, col);
                }
            } else if (typeof col.visible === 'boolean') visible = col.visible;

            if (visible) {
                if (col.config) visible = AntCondition.isVisible(formData, col.config);
            }
            col.visible = visible;
        });

        maxHidingPriority = maxHidingPriority + 1000;

        var ar = [];
        columns.forEach((col) => {
            if (col.hidingPriority === undefined) ar.push(col);
        });
        for (let i = 0; i < ar.length; i++) {
            var col1 = ar[i];
            var col2 = ar[ar.length - i - 1];
            if (col1.hidingPriority === undefined) {
                maxHidingPriority--;
                col1.hidingPriority = maxHidingPriority;
            }
            if (col2.hidingPriority === undefined) {
                maxHidingPriority--;
                col2.hidingPriority = maxHidingPriority;
            }
        }

        if (rawColumns instanceof Array) {
            rawColumns.forEach((rawCol) => {
                var col = columns.find((c) => c.name === 'col' + rawCol.dataField);
                if (col) {
                    var visible = rawCol.visible !== undefined ? Boolean(rawCol.visible) : true;
                    if (typeof rawCol.visible === 'boolean') visible = rawCol.visible;
                    else if (typeof rawCol.visible === 'object') {
                        if (rawCol.visible.type === 'action' && rawCol.visible.field) {
                            visible = false;
                            var condKey = Object.keys(props.searchConditions).find((k) => k === rawCol.visible.field);
                            if (condKey && props.searchConditions[condKey] !== undefined)
                                visible = props.searchConditions[condKey] === rawCol.visible.value;
                        } else if (props.parentData) {
                            visible = AntCondition.isVisible(props.parentData, rawCol);
                        }
                    }

                    if (visible && col.config && typeof col.config.visible === 'object') {
                        visible = AntCondition.isVisible(props.parentData, col.config);
                    }

                    if (!col.editable && rawCol.hideEmpty !== false && dataSource.current) {
                        var isEmptyCol = dataSource.current.isEmptyColumn(rawCol.dataField);
                        visible = visible && !isEmptyCol;
                    }
                    col.visible = visible;
                }
            });

            var count = columns.filter((col) => col.visible && col.width === undefined).length;
            if (count <= 0) {
                rawColumns.forEach((rawCol) => {
                    var col = columns.find((c) => c.name === 'col' + rawCol.dataField);
                    if (col && col.width === undefined) {
                        var visible = rawCol.visible !== undefined ? Boolean(rawCol.visible) : true;

                        if (typeof rawCol.visible === 'boolean') visible = rawCol.visible;
                        else if (typeof rawCol.visible === 'object') {
                            if (rawCol.visible.type === 'action' && rawCol.visible.field) {
                                visible = false;
                                var condKey = Object.keys(props.searchConditions).find((k) => k === rawCol.visible.field);
                                if (condKey && props.searchConditions[condKey] !== undefined)
                                    visible = props.searchConditions[condKey] === rawCol.visible.value;
                            } else if (props.parentData) {
                                visible = AntCondition.isVisible(props.parentData, rawCol);
                            }
                        }

                        if (visible && col.config && typeof col.config.visible === 'object') {
                            visible = AntCondition.isVisible(props.parentData, col.config);
                        }

                        col.visible = visible;
                    }
                });
            }
        }

        var isOK = columns.some((c) => c.visible && c.width === undefined);
        if (!isOK) {
            var col = columns.find(
                (col) => col.visible && Boolean(String(col.dataField).endsWith('description') || String(col.dataField).endsWith('_desc'))
            );
            if (col) col.width = undefined;
            else {
                col = columns.find((col) => col.visible && String(col.dataField).endsWith('variant_dimens'));
                if (col) col.width = undefined;
                else {
                    col = columns.find((col) => col.visible && String(col.dataField).endsWith('item_name'));
                    if (col) col.width = undefined;
                    else {
                        col = columns.find((col) => col.visible && String(col.dataField).endsWith('entity_name'));
                        if (col) col.width = undefined;
                        else {
                            col = columns.find((col) => col.visible && String(col.dataField).endsWith('store_name'));
                            if (col) col.width = undefined;
                            else {
                                col = columns.find((col) => col.visible && String(col.dataField).endsWith('warehouse_name'));
                                if (col) col.width = undefined;
                                else {
                                    col = columns.find((col) => col.visible && String(col.dataField).endsWith('job_title'));
                                    if (col) col.width = undefined;
                                    else {
                                        col = columns.find((col) => col.visible && String(col.dataField).endsWith('business_unit'));
                                        if (col) col.width = undefined;
                                        else {
                                            col = columns.find((col) => col.visible && String(col.dataField).endsWith('department'));
                                            if (col) col.width = undefined;
                                            else {
                                                col = columns.find((col) => col.visible && String(col.dataField).endsWith('status'));
                                                if (col) col.width = undefined;
                                                else {
                                                    col = columns.find((col) => col.visible && String(col.dataField).endsWith('name'));
                                                    if (col) col.width = undefined;
                                                    else {
                                                        col = columns.find((col) => col.visible && String(col.dataField).endsWith('code'));
                                                        if (col) col.width = undefined;
                                                        else {
                                                            col = columns.find((col) => col.visible && String(col.dataField).endsWith('type'));
                                                            if (col) col.width = undefined;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return columns;
    };

    const initDropDownDataSource = () => {
        var source = props.treeOptions.dataSource;
        var valueExpr = props.treeOptions.valueExpr;
        var displayExpr = props.treeOptions.displayExpr;

        var formData = null;
        if (props.formRef) formData = props.formRef.option('formData');

        var displayFormField = props.formDisplayField
            ? props.formDisplayField
            : props.dataField === 'code'
            ? 'name'
            : String(props.dataField).replace('_code', '_name');

        if (displayFormField) {
            if (props.isRemote) {
                source = dataSource.current.getCachedData();
                valueExpr = props.treeOptions.valueExpr;
                displayExpr = props.treeOptions.displayExpr;

                if (formData && formData[displayFormField] !== undefined) {
                    if (source instanceof Array) {
                        var found = source.find((f) => f[valueExpr] === formData[props.dataField]);
                        if (!found) {
                            source.push({
                                [valueExpr]: formData[props.dataField],
                                [displayExpr]: formData[displayFormField]
                            });
                        }
                    }
                }
            } else {
                if (formData && formData[displayFormField] !== undefined) {
                    source = [formData];
                    valueExpr = props.dataField;
                    displayExpr = displayFormField;
                } else {
                    source = props.treeOptions.dataSource;
                    valueExpr = props.treeOptions.valueExpr;
                    displayExpr = props.treeOptions.displayExpr;
                }
            }
        }
        return {
            dataSource: source,
            valueExpr: valueExpr,
            displayExpr: displayExpr
        };
    };

    const rawColumns = useMemo(
        () => (props.treeOptions && props.treeOptions.columns instanceof Array ? JSON.parse(stringify(props.treeOptions.columns)) : []),
        []
    );
    const [mainColumns, setMainColumns] = useState(initColumns());
    const [mainValue, setMainValue] = useState(props.value);

    const [loading, setLoading] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const searchText = useRef('');

    const dataSource = useRef(initDataSource());

    const dropdownDataSource = initDropDownDataSource();

    const [actionConditions, setActionConditions] = useState(initActionConditions());

    const tree = useRef();
    const actionBar = useRef();

    const popUpWidth = props.width ? props.width : '100%';
    const popUpHeight = props.height ? props.height : '60%';

    const showClearButton = !props.showLookupButton && (props.showClearButton !== undefined ? props.showClearButton : true);
    const showDropDownButton = props.showDropDownButton !== undefined ? props.showDropDownButton : true;
    const showLookupButton = props.showLookupButton || props.dataField === 'code' || props.dataField === 'id';

    return (
        <React.Fragment>
            <DropDownBox
                defaultValue={props.value}
                value={mainValue}
                acceptCustomValue={props.acceptCustomValue}
                dataSource={dropdownDataSource.dataSource}
                valueExpr={dropdownDataSource.valueExpr}
                displayExpr={dropdownDataSource.displayExpr}
                placeholder={props.placeholder ? props.placeholder : '...'}
                {...props.editorOptions}
                name={props.name}
                focusStateEnabled={props.focusStateEnabled !== undefined ? Boolean(props.focusStateEnabled) : true}
                showClearButton={showClearButton}
                showDropDownButton={showDropDownButton}
                dropDownOptions={{
                    width: popUpWidth,
                    // height: popUpHeight,
                    shading: true,
                    container: '#root',
                    wrapperAttr: { class: 'ant-dropdown-topmost', style: 'z-index: 2147483647 !important' }
                }}
                rowAlternationEnabled={true}
                loadPanel={{ enabled: false }}
                onOpened={onOpened}
                onInput={(e) => {
                    var opened = e.component.option('opened');
                    if (!opened) e.component.open();
                    if (props.acceptCustomValue) {
                        onSearchText(e.component.option('text'));
                    }
                }}
                onKeyDown={(e) => {
                    let keyCode = e.event.key;
                    if (keyCode === 'Enter' || keyCode === 'Tab') e.component.close();
                }}
                onFocusIn={(e) => {
                    let inputEl = e.element.querySelector('.dx-texteditor-input');
                    if (inputEl) {
                        inputEl.selectionStart = 0;
                        inputEl.selectionEnd = inputEl.value.length;
                    }
                    if (props.onFocusIn)
                        props.onFocusIn({
                            dataField: props.dataField
                        });
                }}
                onFocusOut={(e) => {
                    var newValue = e.component.option('value');
                    if (newValue !== mainValue) setMainValue(newValue);
                }}
                onValueChanged={(e) => {
                    if ((e.value === '' || e.value === null) && mainValue !== '' && mainValue !== null) {
                        setMainValue(null);
                        if (props.onValueChanged)
                            props.onValueChanged({
                                value: null,
                                rowData: null
                            });
                    } else {
                        if (props.onValueChanged)
                            props.onValueChanged({
                                value: e.value
                            });
                    }
                }}
                contentRender={(e) => {
                    var showSearchBar = false;

                    var searchBarWidth = props.width;
                    if (props.treeOptions.searchBar === true) {
                        searchBarWidth = 150;
                        showSearchBar = true;
                    } else if (
                        typeof props.treeOptions.searchBar === 'object' &&
                        props.treeOptions.searchBar !== null &&
                        props.treeOptions.searchBar.width
                    ) {
                        searchBarWidth = props.treeOptions.searchBar.width;
                        showSearchBar = true;
                    }
                    showSearchBar = showSearchBar && !props.acceptCustomValue;
                    return (
                        <React.Fragment>
                            {(showSearchBar || props.treeOptions.actionItems instanceof Array) && (
                                <AntGridBar
                                    ref={(ref) => {
                                        that.actionBar = ref;
                                    }}
                                    showSearchBar={Boolean(props.treeOptions.searchBar)}
                                    showFieldChooser={false}
                                    showRefresh={false}
                                    autoFocusSearchBar={false}
                                    locationSearchBar={'before'}
                                    focusStateEnabled={false}
                                    searchBarWidth={searchBarWidth}
                                    onSearchText={onSearchText}
                                    onAction={onAction}
                                    items={props.treeOptions.actionItems instanceof Array ? props.treeOptions.actionItems : []}
                                />
                            )}

                            <TreeList
                                ref={tree}
                                noDataText={AntLocalization.translateText({ vi: 'Không có dữ liệu !', en: 'Have no data !', fr: 'Aucune donnée !', es: '¡Sin datos!', id: 'Tidak ada data!', ja: 'データがありません！', zh: '没有数据！', ko: '데이터 없음!', hi: 'कोई डेटा नहीं!', ar: 'لا توجد بيانات!' })}
                                // remoteOperations={props.isRemote}
                                dataSource={props.isRemote && dataSource.current ? dataSource.current.instance() : props.treeOptions.dataSource}
                                keyExpr={props.treeOptions.valueExpr}
                                parentIdExpr={props.treeOptions.parentIdExpr}
                                displayExpr={props.treeOptions.displayExpr}
                                selectByClick={true}
                                // autoExpandAll={true}
                                rootValue={null}
                                showColumnHeaders={props.treeOptions.showHeader !== false && mainColumns && mainColumns.length > 1}
                                columns={mainColumns}
                                columnAutoWidth={true}
                                allowColumnResizing={true}
                                columnResizingMode={'nextColumn'}
                                hoverStateEnabled={true}
                                focusStateEnabled={true}
                                rowAlternationEnabled={true}
                                wordWrapEnabled={false}
                                loadPanel={{ enabled: false }}
                                keyboardNavigation={
                                    props.keyboardNavigation !== undefined
                                        ? props.keyboardNavigation
                                        : {
                                              enabled: false
                                          }
                                }
                                selectedRowKeys={[mainValue !== undefined && mainValue !== null ? mainValue : undefined]}
                                onSelectionChanged={(e2) => {
                                    var newValue = e2.selectedRowKeys[0];

                                    var previousValue = mainValue;

                                    // if (newValue != mainValue) {
                                    setMainValue(newValue);
                                    if (newValue !== null && newValue !== undefined) {
                                        e.component.close();
                                        if (props.onValueChanged)
                                            props.onValueChanged({
                                                value: newValue,
                                                previousValue: previousValue,
                                                rowData:
                                                    e2.selectedRowsData instanceof Array && e2.selectedRowsData.length > 0
                                                        ? e2.selectedRowsData[0]
                                                        : null
                                            });
                                    }
                                    // }
                                }}
                                onInitialized={(e) => {
                                    e.component.columnOption('command:adaptive', 'visible', false);
                                }}
                                height={props.height ? props.height : '300'}
                                width={props.width ? props.width : undefined}
                            >
                                <Selection mode="single" />
                                <Scrolling mode="infinite" />
                                {/* <Paging enabled={true} pageSize={10} /> */}
                                <FilterRow visible={props.treeOptions.showFilter} />{' '}
                                <Template name={'renderCheckboxCell'} render={renderCheckboxCell} />
                            </TreeList>
                        </React.Fragment>
                    );
                }}
            >
                {props.validationRules && <Validator validationRules={props.validationRules} dataField={props.dataField} />}
            </DropDownBox>
        </React.Fragment>
    );
}
